<template>
  <div id="email" style="width:600px; margin: 0 auto; display: block;">
      <header class="header-email" >
        <div class="brand" style="border-bottom: 1px solid rgb(204,204,204);padding-bottom: 6px;">
          <figure class="logo-sistema" style="display: inline-block;vertical-align: middle;width: 51%;">
              <img src="../../assets/imagens/logo-domus.png" alt="">
          </figure>
            <div class="site" style="display: inline-block;vertical-align: middle;">
              <a href="https://habix.agehab.ms.gov.br/controledesaldo/" target="_blank" style="color: rgb(0,102,153);font-size: 13px;">
                habix.agehab.ms.gov.br/controledesaldo
              </a>
            </div>
        </div>
        <section style="display: inline-block; vertical-align: middle; width: 100%; margin: 10px 0; text-align: right;">
           <strong style="display: block; font-size: 22px; font-weight: 600;">Situação da solicitação</strong>
           de Jose Carlos Balabuch
        </section>

      </header>
      <main>
        <h1 style="font-size: 21px; color: rgb(128, 5, 34); margin: 15px 0; font-weight: 600;">Olá, Bárbara</h1>
        <div class="status-reservado" style=" margin:10px 0;">
          <p style="font-size: 17px; line-height: 24px;">

            A solicitação de <strong>Jose Carlos Balabuch </strong>foi para a situação de <strong>reservado</strong> pela AGEHAB
          </p>
        </div>
        <div class="solicitar-cancelamento" style=" margin:10px 0;">
          <p style="font-size: 17px; line-height: 24px;">
            O Agente financeiro solicitou cancelamento para a solitação de <strong>Jose Carlos Balabuch </strong>.
            <br>
            Motivo: Houve deistencia do financiamento por parte do solicitante.
          </p>
        </div>
        <div class="status-solicitado"  style="margin:10px 0;">
          <p>
            Foi criada uma solicitação para <strong>Evelyn Chiavagatti</strong> pelo agente financeiro Diogonc
          </p>
        </div>
        <div class="status-reservado"  style="margin:10px 0;">
          <p>
            A solicitação de <strong>Jose Carlos Balabuch</strong> foi <strong> Autorizado pagamento</strong> pela AGEHAB
          </p>
        </div>
        <button style="background-color: #800522; border:none; border-radius: 3px; color: #fff;    padding: 10px;width: 100%;margin: 10px 0;font-size: 16px;
    display: block;cursor:pointer;">ver solicitação</button>

        <div style="margin: 10px 0;font-size: 15px;font-weight: 600;">
        Até a próxima!</div>
      </main>
      <footer style="padding:10px 0; font-size: 11px; color: rgb(102,102,102); line-height: 16px;font-family: Arial,sans-serif; border-top: 1px solid rgb(204,204,204); padding-top: 6px;">
        Observação: Este é um e-mail de notificação e foi gerado automaticamente. Por favor, não responda esta mensagem.
      </footer>

  </div>
</template>

<script>
export default {
  name: 'email',
};
</script>



// WEBPACK FOOTER //
// Email.vue?93e8549a